import * as React from 'react';
import { useState } from 'react';
import { Search } from '@mui/icons-material';
import { useEffect } from 'react';

interface ISearchBoxProps {
    search: (value: string) => void;
    value?: string;
    placeholder?: string;
    onChange?: (value: string) => void;
    onKeyPress?: (e: React.KeyboardEvent<HTMLInputElement>) => boolean;
    searchDisabled?: boolean;
    searchDelayMs?: number;
}

export const SearchBox = (props: ISearchBoxProps) => {
    const [searchText, setSearchText] = useState(props.value ?? "");
    const [searchTextEvent, setSearchTextEvent] = useState({ autoSearch: false });
    const [searchTimer, setSearchTimer] = useState(undefined as NodeJS.Timeout | undefined);
    const [searchDelayMs] = useState(props.searchDelayMs || 300);

    const search = () => {
        console.log("Searching for: " + searchText);
        props.search(searchText);
    };

    const searchTextSet = (text: string) => {
        setSearchText(text);
        setSearchTextEvent({ autoSearch: true });
    }

    useEffect(() => {
        if (searchTextEvent && !searchTextEvent.autoSearch) {
            return;
        }

        if (searchTimer) {
            clearTimeout(searchTimer);
        }

        if (!searchText || searchText.length < 2) {
            return;
        }

        let timer = setTimeout(() => search(), searchDelayMs);
        setSearchTimer(timer);

        return () => {
            if (!searchTimer) {
                clearTimeout(searchTimer);
            }
        };
    }, [searchTextEvent]);

    return (
        <div key={"simpleTextbox"} className="search-box">
            <input type="text"
                className="list-filter-box"
                value={searchText}
                onChange={e => { searchTextSet(e.target.value); }}
                placeholder={props.placeholder}
                onKeyPress={e => {
                    if (e.key === 'Enter') {
                        search();
                        return false;
                    }
                    return true;
                }}
            />

            {!props.searchDisabled &&
                <button className="search-button" onClick={() => { search(); }}><Search /></button>
            }
        </div>
    );
};
